<template lang="">
    <div>
        <v-table url="tag" :only="['name','description']" :sn="false"/>
    </div>
</template>
<script>
export default {};
</script>